import { useTranslation } from 'react-i18next';
import { useIsMobile } from '../../../hooks/use-is-mobile.hook';
import Sidebar from '../../../common/sidebar-right/sidebar.component';
import BottomSidebar from '../../../common/sidebar-bottom/bottom-sidebar.component';
import { BottomSidebarTitle } from '../../../common/sidebar-bottom/bottom-sidebar.styles';

import GenericInfoBlock from '../../../common/generic-info-block/generic-info-block.component';
import { IGenericInfoBlock } from '../../../models/generic-info-block/generic-info-block';
import { theme } from '../../../styles/themes';
import { client } from '../../../config';

interface Props {
  hintsInfo: IGenericInfoBlock | undefined;
}

const getSidebarBackgroundColor = () => {
  if (client === 'polonez') {
    return theme.colors.baseColors.red8;
  }

  return theme.colors.baseColors.blue0;
};

const HintsSidebar = ({ hintsInfo }: Props) => {
  const { t } = useTranslation();
  const isMobile = useIsMobile();

  if (!hintsInfo) return;

  const hintsContent = (
    <GenericInfoBlock
      genericInfo={hintsInfo}
      mode='hints'
    />
  );

  return isMobile ? (
    <BottomSidebar
      name='delivery_options_hints'
      height='90dvh'
      withBlurredBackground
      backgroundColor={getSidebarBackgroundColor()}
      mobPadding='1.6rem 1.6rem 3.2rem 1.6rem'>
      <BottomSidebarTitle>
        {t('delivery_options_hint_header')}
      </BottomSidebarTitle>
      {hintsContent}
    </BottomSidebar>
  ) : (
    <Sidebar
      contentWithVerticalScroll
      name='delivery_options_hints'
      header={t('delivery_options_hint_header')}
      withBlurredBackground
      backgroundColor={getSidebarBackgroundColor()}>
      {hintsContent}
    </Sidebar>
  );
};

export default HintsSidebar;
